import React, { useEffect, useState } from "react";
import Button from "elements/Button";
import { formatPrice, titleShorten } from "utils/Formatter";

export default function Product(props) {
  const [active, setActive] = useState("All");
  const [product, setProduct] = useState({ isLoading: true, data: [] });
  const [sortBy, setSortBy] = useState(null);

  const filterCategory = (category) => {
    setActive(category);
  };

  const filterSort = (sort) => {
    setSortBy(sort);
  };

  useEffect(() => {
    if (active === "All") {
      if (props.product) setProduct(props.product.data);
    } else {
      if (props.product)
        setProduct(
          props.product.data.filter((item) => item.categories.name === active)
        );
    }
  }, [active, props.product]);

  return (
    <section className="section-product-landingpage mb-5" id="productSection">
      <div className="container">
        <h3>Kategori</h3>
        <div className="d-flex justify-content-start">
          <div className="justify-content-start">
            <Button
              className={`btn me-3 ${active === "All" ? "btn-primary" : ""}`}
              hasShadow
              onClick={() => filterCategory("All")}
            >
              All
            </Button>
            {props.category ? (
              props.category.data.map((item, index) => {
                return (
                  <Button
                    className={`btn me-3 ${
                      active === item.name ? "btn-primary" : ""
                    }`}
                    hasShadow
                    key={index}
                    onClick={() => filterCategory(item.name)}
                  >
                    {item.name}
                  </Button>
                );
              })
            ) : (
              <Button className="btn me-3" isLoading></Button>
            )}
          </div>

          <div className="divider me-3"></div>

          <div className="dropdown">
            <button
              className="btn btn-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {sortBy ? `Sort By : ${sortBy}` : "Sort By"}
            </button>
            <ul className="dropdown-menu">
              <Button
                className="dropdown-item"
                onClick={() => filterSort("Highest Price")}
              >
                Highest Price
              </Button>

              <Button
                className="dropdown-item"
                onClick={() => filterSort("Lowest Price")}
              >
                Lowest Price
              </Button>
            </ul>
          </div>
        </div>

        <div className="row product mt-4">
          {product.isLoading
            ? "Loading..."
            : product.length > 0
            ? product
                .sort((a, b) => {
                  if (sortBy === "Highest Price") {
                    return b.price - a.price;
                  } else if (sortBy === "Lowest Price") {
                    return a.price - b.price;
                  } else {
                    return a.id - b.id;
                  }
                })
                .map((item, index) => {
                  return (
                    <div className="col-3 mb-3" key={index}>
                      <div className="card">
                        <figure className="img-wrapper">
                          <img
                            src={item ? item.image : ""}
                            alt={item.name}
                            className="img-fluid"
                          />
                        </figure>
                        <div className="meta-wrapper">
                          <Button
                            type="link"
                            href={`/product/${item.id}`}
                            className="stretched-link d-block"
                          >
                            <h5 className="title">
                              {titleShorten(item.name, 40, " ")}{" "}
                            </h5>
                          </Button>
                          <p>{item.categories.name}</p>
                          <h5>Rp. {formatPrice(item.price)}</h5>
                        </div>
                      </div>
                    </div>
                  );
                })
            : "No Data"}
        </div>
      </div>
    </section>
  );
}
